import React, { memo } from "react";
import { Redirect } from "react-router-dom";

const ToChallengePresentation = () => {
  return <Redirect to="/challenges/presentation" />;
};

export default memo(ToChallengePresentation);
